import React, { Component } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import AdminBar from "../AdminBar";

const root = document.body;

class AdminBarContainer extends Component {
  static propTypes = {
    session: PropTypes.object.isRequired,
  };

  state = {
    opened: false,
  };

  componentDidMount() {
    document.documentElement.classList.add("with-admin-bar");
  }

  handleButtonClick = () => {
    this.setState({ opened: true });
  };

  handleButtonMouseEnter = () => {
    this.setState({ opened: true });
  };

  handleButtonMouseLeave = () => {
    this.setState({ opened: false });
  };

  render() {
    const { session } = this.props;

    if (session.administrationAccess === false && session.crmAccess === false && session.impersonating === false) {
      return null;
    }

    return createPortal(
      <AdminBar
        session={session}
        opened={this.state.opened}
        onClickButton={this.handleButtonClick}
        onMouseEnterButton={this.handleButtonMouseEnter}
        onMouseLeaveButton={this.handleButtonMouseLeave}
      />,
      root
    );
  }
}

export default AdminBarContainer;
